import React, { useState } from "react";
import AlertMessage from "../../../../partials/alertMessage";

const UpdateAssessmentType = ({
	onSubmit,
	currentValue,
	onCancel,
	title,
	icon
}) => {
	const [message, setMessage] = useState(null);
	const nameRef = React.createRef();
	const iconRef = React.createRef();
	// Update current value
	setTimeout(() => {
		if (nameRef && nameRef.current) nameRef.current.value = currentValue;
		if (iconRef && iconRef.current) iconRef.current.value = icon;
	}, 0);
	return (
		<form
			method="POST"
			onSubmit={e => {
				e.preventDefault();
				const name = nameRef.current.value;
				const icon = iconRef.current.value;
				if (name) {
					onSubmit({ name, icon });
					setMessage(null);
					nameRef.current.value = "";
					iconRef.current.value = "";
				} else {
					setMessage(`Assessment ${title}'s name is required!`);
				}
			}}
		>
			<AlertMessage message={message} failed={true} />
			<div className="form-row">
				<div className="col">
					<input
						type="text"
						id={`update-${title}`}
						name={`update-${title}`}
						ref={nameRef}
						className="form-control input-height"
						placeholder={`assessment ${title} name..`}
					/>
				</div>
				{title === "Type" && (
					<div className="col">
						<input
							type="text"
							id="icon-id"
							name="icon-id"
							ref={iconRef}
							className="form-control input-height"
							placeholder="enter icon"
						/>
					</div>
				)}

				<div className="col">
					<button
						type="button"
						onClick={() => onCancel()}
						className="mdl-button mdl-js-ripple-effect m-l-10 m-t-5 btn-circle"
					>
						<i className="material-icons text-danger">cancel</i> Cancel
					</button>
				</div>
				<div className="col">
					<button
						type="submit"
						className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 m-t-5 btn-circle btn-success"
					>
						Update {title} <i className="material-icons">arrow_right_alt</i>
					</button>
				</div>
			</div>
		</form>
	);
};
export default UpdateAssessmentType;
